module.exports = ".modal-dialog {\n  width: 75%;\n  max-height: 95%;\n  max-width: none;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/serasa/component/serasa/concentre-legado/concentre-legado.component.scss
// module id = ./src/app/serasa/component/serasa/concentre-legado/concentre-legado.component.scss
// module chunks = main